// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useTranslation } from "react-i18next";

export function ContextDivider({ label }: { label: string }) {
  const { t } = useTranslation();
  return (
    <div className="my-3 flex items-center gap-2 text-[11px] text-muted-foreground before:h-px before:flex-1 before:bg-border after:h-px after:flex-1 after:bg-border">
      {t("assistant.contextDivider", { context: label })}
    </div>
  );
}
